<div class="maincontentarea" id="maincontentarea">
    <section class="my_account">

        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h4 class="accmain-head">Favourites
                        <!-- <a  *ngIf="fav_list2.length"class="favourite_edit_link"  (click)="openModal(EditFavourites)"href="javascript:;">Edit</a> -->
                    </h4>
                </div>
            </div>
            <h4 class="category-name mt-2">{{category_name}} <a style="margin-top: 0;" *ngIf="fav_list2.length"
                    class="favourite_edit_link" (click)="openModal(EditFavourites,category_id)"
                    href="javascript:;">Edit</a></h4>
            <div *ngFor="let category of fav_list2" [hidden]="(category._id) != category_id">


                <div class="row ">
                    <div class="col-md-4" *ngFor="let item of category.category_tab">

                        <div class="favourite_guruji">
                            <!-- <img src="../../../../assets/img/guruji_img.jpg" alt="" title="" /> -->
                            <!-- <img *ngIf="!item.category_image && isCloudFrontType == false" src="assets/img/not-found/{{notFoundImg}}.png" class="grid_item not_found_img" alt="grid_img"> -->
                            <image-manipulation
                                [img]="isCloudFrontType == false ? item.thumbnail_square || item.category_image : item.thumbnail_square_cloudfront_url || item.category_image_cloudfront_url"
                                [params]="assetImgParam"></image-manipulation>
                            <span class="guruji_name">{{item.sub_category_name}}</span>
                        </div>
                    </div>

                    <!-- <div class="col-md-4">
                    <div class="favourite_guruji">
                        <img src="../../../../assets/img/guruji_img.jpg" alt="" title="" />
                        <span class="guruji_name">Sadhguru</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="favourite_guruji">
                        <img src="../../../../assets/img/guruji_img.jpg" alt="" title="" />
                        <span class="guruji_name">Sadhguru</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="favourite_guruji">
                        <img src="../../../../assets/img/guruji_img.jpg" alt="" title="" />
                        <span class="guruji_name">Sadhguru</span>
                    </div>
                </div> -->
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 mt-5"
                    [ngClass]="{'text-right': fav_list2.length,'text-center': !fav_list2.length}">
                    <a href="javascript:;" (click)="openModal(AddFavourites)" class="favourite_btn">Add Guru
                        Ji</a>
                </div>
            </div>
        </div>
    </section>
</div>

<ng-template #AddFavourites let-modal>
    <div class="auth">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Choose your favourite guruji</h4>
                    <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button>
                </div>
                <div class="modal-body">
                    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                    <div class="catg">
                        <ul class="guruji" *ngFor="let category of all_list"
                            [hidden]="(category.category_id) != category_id">
                            <!-- <li class="category-name"> <label for="">{{category.category_name}}</label></li> -->
                            <li *ngFor="let guruji of category.category_tab">
                                <label>
                                    <div class="favourite_guruji">
                                        <!-- <img src="../../../../assets/img/guruji_img.jpg" alt="" title="" /> -->

                                        <!-- <img *ngIf="!guruji.category_image && isCloudFrontType == false" src="assets/img/not-found/{{notFoundImg}}.png" class="grid_item not_found_img" alt="grid_img"> -->
                                        <image-manipulation
                                            [img]="isCloudFrontType == false ? guruji.thumbnail_square || guruji.thumbnail : guruji.thumbnail_square_cloudfront_url || guruji.thumbnail_cloudfront_url"
                                            [params]="assetImgParam"></image-manipulation>

                                        <span class="guruji_name">{{guruji.sub_category_name}}</span>
                                        <div class="round">
                                            <input type="checkbox" (change)="changeFavourite($event,guruji)"
                                                [checked]='guruji.is_favourite == 1' />
                                            <span for="checkbox"></span>
                                        </div>
                                    </div>
                                </label>
                            </li>

                        </ul>
                    </div>
                    <!-- <a href="javascript:;" class="favourite_btn favourite_btn_block mt-3" data-dismiss="modal" (click)="submitFavourite()">Submit</a> -->
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #EditFavourites>
    <div class=" auth">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                    <h4 class="modal-title">Edit</h4>
                    <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button>
                </div>
                <div class="modal-body example-container">
                    <div class="catg">
                        <ul class="guruji example-list" cdkDropList #todoList="cdkDropList"
                            [cdkDropListData]="edit_fav_list" (cdkDropListDropped)="reorder($event)">
                            <li class="example-box" *ngFor="let guruji of edit_fav_list" cdkDrag>
                                <label>
                                    <div class="favourite_guruji">
                                        <img src="../../../../assets/img/move.png" alt="" title="" class="move_img" />
                                        <!-- <img *ngIf="!guruji.category_image && isCloudFrontType == false" src="assets/img/not-found/{{notFoundImg}}.png" class="grid_item not_found_img" alt="grid_img"> -->
                                        <image-manipulation
                                            [img]="isCloudFrontType == false ? guruji.thumbnail_square || guruji.category_image : guruji.thumbnail_square_cloudfront_url || guruji.category_image_cloudfront_url"
                                            [params]="assetImgParam"></image-manipulation>
                                        <span class="guruji_name">{{guruji.sub_category_name}} </span>
                                        <a class="guruji_remove_icon" href="javascript:;"
                                            (click)="removeFavourite(guruji)">&times;</a>
                                    </div>
                                </label>
                            </li>




                        </ul>
                    </div>
                    <!-- <a href="javascript:;" class="favourite_btn favourite_btn_block mt-3" data-dismiss="modal" (click)="saveEdit()">Save</a> -->
                </div>
            </div>
        </div>
    </div>
</ng-template>